

/**
* 站点本地存储TokenKey
*/
export const siteTokenKey = "iyuanwu_token";

/**
 * Ajax请求头TokenKey
 */
export const ajaxHeadersTokenKey = "token";

/**
 * 站点登录路由地址
 */
export const siteLoginRouter = process.env.VUE_APP_LOGIN_URL;


/**
 * ajax请求 - 返回数据 - 不添加前置验证的 URL
 */
export const ajaxResponseNoVerifyUrl = [
    '/user/login', // 用户登录
    '/user/info' // 获取用户信息
];
